import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../../Member/Navbar/Navbar";
import "./profile.css";
import ServiceAdmin from "../Services/ServiceAdmin";
import checkAuth from "../../../Login/Services/check-auth";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import {
  Container,
  Row,
  Col,
  Modal,
  Form,
  Button,
  Tabs,
  Tab,
  Alert as AlertControl,
} from "react-bootstrap";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ServiceProfile from "./Service/ServiceProfile";
import FormService from "./FormService";
import AddBoxIcon from "@material-ui/icons/AddBox";
import { ListServiceContext } from "../../../App";
const Services = (props) => {
  const currnetUser = JSON.parse(sessionStorage.getItem("user"));
  //// Edit  Profile
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const idUser =
    JSON.parse(sessionStorage.getItem("user")) &&
    JSON.parse(sessionStorage.getItem("user")).id;
  // get data from profile

  useEffect(() => {
    getprofileInfo();
  }, []);

  //
  const healthPro =
    JSON.parse(sessionStorage.getItem("healthId")) &&
    JSON.parse(sessionStorage.getItem("healthId")).id;
  const [profileInfos, setProfileInfos] = useState();
  const [details, setDetails] = useState();
  const getprofileInfo = () => {
    ServiceAdmin.getprofile(healthPro).then((res) => {
      console.log("api get ", res.data.laboratory);
      if (res.data) {
        setProfileInfos(res.data);
        setDetails(JSON.parse(res.data.details));
        // setDetailsInfo(JSON.parse(res.data.laboratory));
        sessionStorage.setItem(
          "dataCabinet",
          JSON.stringify(res.data.laboratory ? res.data.laboratory : {})
        );
      }
    });
  };

  //  services
  // check labo or midecin
  const profSanteSpeciality =
    JSON.parse(sessionStorage.getItem("profSante")) &&
    JSON.parse(sessionStorage.getItem("profSante")).speciality;
  const profSante =
    JSON.parse(sessionStorage.getItem("profSante")) &&
    JSON.parse(sessionStorage.getItem("profSante"));
  /// State Context

  const { listService, setlistService } = useContext(ListServiceContext);

  // Props
  const { showService, ToggleService } = props;

  /// State

  const [rowService, setRowService] = useState();
  const [checkForm, setSheckForm] = useState("ADD");
  const [idS, setIdS] = useState();
  console.log("listService", listService);

  //Modal
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const HandelClick = () => {
    setMessage("fadili");
    setSeverity("warning");
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    ToggleService();
  };

  // Set input Service

  const handleInput = (idS) => {
    console.log(idS);
    const row = listService.filter((x) => x.id == idS);
    console.log(row);
    if (row) {
      setRowService(row);
    }
  };

  console.log("rowService", rowService);

  //Table

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      &thinsp; De {from} à {to} sur {size} Service
    </span>
  );
  const { SearchBar } = Search;
  const options = {
    paginationSize: 4,
    pageStartIndex: 0,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,

    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "25",
        value: 25,
      },
      {
        text: "Plus",
        value: listService.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };

  // const defaultSorted = [
  //   {
  //     dataField: "denomination",
  //     dataField: "id",
  //     dataField: "price",
  //     order: "desc",
  //   },
  // ];

  const columns = !profSanteSpeciality
    ? [
        {
          dataField: "denomination",
          text: "Prestation",
          headerAlign: "center",
          align: "left",
          sort: true,
        },
        {
          dataField: "price",
          text: "Price",
          headerAlign: "center",
          align: "center",
          sort: true,
        },

        {
          dataField: "type",
          text: "Type",
          headerAlign: "center",
          align: "center",
          sort: true,
        },
        {
          dataField: "action",
          text: "Actions",
          headerAlign: "center",
          align: "center",
          sort: true,
        },
      ]
    : [
        {
          dataField: "denomination",
          text: "Prestation",
          headerAlign: "center",
          align: "left",
          sort: true,
        },
        {
          dataField: "price",
          text: "Prix",
          headerAlign: "center",
          align: "center",
          sort: true,
        },

        {
          dataField: "action",
          text: "Actions",
          headerAlign: "center",
          align: "center",
          sort: true,
        },
      ];

  // modal update admin
  const [showAdmin, setShowAdmin] = useState(false);
  const [adminId, setAdminId] = useState();
  const [show, setShow] = useState(false);
  const HandleShow = (id) => {
    setAdminId(id);
    setShowAdmin(true);
  };
  const ToggleAdmin = () => {
    setShowAdmin(false);
  };
  const Toggle = () => {
    setShow(false);
  };
  // const test = [...listService];
  // console.log(listService, "this is ... listService", test);
  const toggleStatus = (id, enabled) => {
    // ServiceAdmin.changeStatus(id);
    const newData = [...listService];

    const foundedUserIndex = listService.findIndex((item) => item.id === id);

    newData[foundedUserIndex].enabled = !enabled;
    setlistService(newData);
    console.log(id);
  };
  useEffect(() => {
    //setId(JSON.parse(sessionStorage.getItem("user")).id);
    getService();
  }, [JSON.parse(sessionStorage.getItem("dataCabinet")).id]);

  const getService = () => {
    ServiceProfile.getServiceId(
      JSON.parse(sessionStorage.getItem("dataCabinet")).id
    ).then((res) => {
      setlistService(res.data);
    });
  };

  console.log(listService);

  const infouser = [];

  listService.map((info, i) => {
    infouser.push({
      denomination: info.designation,
      price: info.price,
      type: info.type,
      action: [
        <>
          <Button
            className="mr-2 ml-2 print"
            variant="info"
            onClick={() => {
              setSheckForm("Edit");
              handleInput(info.id);
              setIdS(info.id);
            }}
          >
            <EditIcon />
          </Button>

          <Button
            className="mr-2"
            variant="danger"
            onClick={() => {
              setIdS(info.id);
              setShow(true);
            }}
          >
            <DeleteIcon />
          </Button>
        </>,
      ],
    });
  });

  //console.log("enabled ", !listService[0].enabled, listService[0].role);
  function customMatchFunc({ searchText, value, column, row }) {
    if (typeof value !== "undefined") {
      return value.startsWith(searchText);
    }
    return false;
  }

  // delete Service by id
  const deleteServiceById = (id) => {
    ServiceProfile.deleteServise(id).then((res) => {
      setlistService(listService.filter((x) => x.id !== id));
      setShow(false);
    });
  };
  console.log(idS);
  return (
    <>
      <Snackbar open={open} autoHideDuration={40000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
      <Navbar />

      <div
        className="container bootstrap snippets bootdeys"
        style={{ marginTop: "20px" }}
      >
        <div className="row" id="user-profile">
          <div className="col-lg-3 col-md-4 col-sm-4">
            <div className="main-box clearfix">
              <h2>
                {profSante && `${profSante.firstName} ${profSante.lastName} `}
              </h2>
              {/* <div className="profile-status">
                <i className="fa fa-check-circle"></i> Online
              </div> */}
              <img
                src="https://bootdey.com/img/Content/avatar/avatar1.png"
                alt=""
                width="100%"
                className="profile-img img-responsive center-block"
              />
              <div className="profile-stars">
                <div className="profile-user-details clearfix">
                  <div className="profile-user-details-label">
                    <b>Address:</b>
                  </div>
                  <div className="profile-user-details-value">
                    {profSante && profSante.laboratory
                      ? profSante.laboratory.address
                      : "-"}
                    <br />
                    {profSante && profSante.city ? profSante.city.name : "-"}
                  </div>
                </div>
                <div className="profile-user-details clearfix">
                  <div className="profile-user-details-label">
                    <b>Email:</b>
                  </div>
                  <div className="profile-user-details-value">
                    {profSante && profSante.email}
                  </div>
                </div>
                <div className="profile-user-details clearfix">
                  <div className="profile-user-details-label">
                    <b>Phone:</b>
                  </div>
                  <div className="profile-user-details-value">
                    {profSante && profSante.tel}
                  </div>
                </div>
              </div>
              {details && (
                <div className="profile-details">
                  <ul className="fa-ul">
                    <li>
                      <i className="fa-li fa fa-linkedin-square"></i>
                      <a
                        href={details.sociaux && details.sociaux.linkedin}
                        target="_blank"
                      >
                        Linkdin
                      </a>
                    </li>
                    <li>
                      <i className="fa-li fa fa-facebook-square"></i>
                      <a
                        href={details.sociaux && details.sociaux.facebook}
                        target="_blank"
                      >
                        Facebook{" "}
                      </a>
                    </li>
                    <li>
                      <i className="fa-li fa fa-instagram"></i>
                      <a
                        href={details.sociaux && details.sociaux.instagram}
                        target="_blank"
                      >
                        Instagram
                      </a>
                    </li>
                  </ul>
                </div>
              )}

              {checkAuth && currnetUser && currnetUser.role === "ADMIN" ? (
                ""
              ) : checkAuth && currnetUser && currnetUser.role === "USER" ? (
                ""
              ) : (
                <div className="profile-message-btn center-block text-center">
                  <Link
                    to={
                      currnetUser
                        ? profileInfos && profileInfos.speciality
                          ? "/pageanalyse"
                          : "/home"
                        : "/login"
                    }
                  >
                    <Button
                      className="m-auto "
                      variant="primary"
                      style={{ fontSize: "smaller", color: "white" }}
                      onClick={() => {
                        // sessionStorage.setItem(
                        //   "Type",
                        //   JSON.stringify({
                        //     type: "No Covid",
                        //   })
                        // );
                        profileInfos &&
                          sessionStorage.setItem(
                            "lieux",
                            JSON.stringify(
                              profileInfos.laboratory
                                ? profileInfos.laboratory
                                : {}
                            )
                          );
                      }}
                    >
                      <i
                        className="fas fa-calendar-check mr-2"
                        style={{
                          color: "white",
                          backgroundColor: "#0596de",
                        }}
                      ></i>
                      PRENDRE RENDEZ-VOUS
                    </Button>
                  </Link>
                </div>
              )}
            </div>
          </div>

          <div className="col-lg-9 col-md-8 col-sm-8">
            <div className="main-box clearfix">
              {currnetUser && currnetUser.role == "ADMIN" && (
                <div className="profile-header">
                  <Link to="/profile">
                    <Button className="btn ml-2 mb-2 btn-info edit-profile">
                      <AccountBoxIcon /> Profile
                    </Button>
                  </Link>
                </div>
              )}
              {currnetUser && currnetUser.role == "USER" && (
                <div className="profile-header">
                  <Link to="/profile">
                    <Button className="btn ml-2 mb-2 btn-info edit-profile">
                      <AccountBoxIcon /> Profile
                    </Button>
                  </Link>
                </div>
              )}
              <div className="profile-header">
                <h6
                  style={{
                    marginTop: "27px",
                    marginBottom: "18px",
                    fontSize: "x-large",
                  }}
                >
                  Liste des Services :
                </h6>

                <Container>
                  <FormService
                    Edit={checkForm}
                    rowService={rowService}
                    idS={idS}
                  />
                  <hr />
                  <div className="data">
                    <Modal show={show} onHide={Toggle}>
                      <Modal.Body>
                        <img
                          src="https://img.icons8.com/fluent/48/000000/close-window.png"
                          style={{ float: "right" }}
                          onClick={Toggle}
                        />
                        <h6
                          style={{
                            marginTop: "27px",
                            marginBottom: "18px",
                            textAlign: "center",
                          }}
                        >
                          Êtes-vous sûr d'annuler ce compte ?
                        </h6>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="info"
                          onClick={() => deleteServiceById(idS)}
                        >
                          Oui
                        </Button>

                        <Button className="mr-auto" variant="danger">
                          Non
                        </Button>
                      </Modal.Footer>
                    </Modal>

                    <Col xs={12} className="mb-4">
                      <ToolkitProvider
                        keyField="id"
                        data={infouser}
                        columns={columns}
                        search={{ customMatchFunc }}
                      >
                        {(props) => (
                          <div>
                            <SearchBar {...props.searchProps} />
                            {/* <AddBoxIcon
                      variant="info"
                      onClick={() => {
                        setSheckForm("ADD");
                      }}
                      style={{
                        float: "right",
                        fontSize: "45px",
                        color: "#007bff",
                      }}
                    /> */}
                            <BootstrapTable
                              striped
                              {...props.baseProps}
                              // defaultSorted={defaultSorted}
                              pagination={paginationFactory(options)}
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    </Col>
                  </div>
                </Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;
